import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import ApplicarionConfigService from "../../api/ApplicationConfigService";
// import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import Select from "react-select";
import { useEffect } from "react";
import ReportServices from "../../api/ReportServices";
import $ from "jquery";
import exportToExcel from "../CommonServices/exporttoexcel";
import IconButton from "@mui/material/IconButton";
import GetAppIcon from "@mui/icons-material/GetApp";
import Tooltip from "@mui/material/Tooltip";
const repObj = new ReportServices();
const AppService = new ApplicarionConfigService();

const FundReport = () => {
  const datecurre = new Date();
  const [monthFilter, setMonthFilter] = useState(datecurre.getMonth() + 1); // Set default to current month
  const [yearFilter, setYearFilter] = useState(datecurre.getFullYear());
  const [typeFilter, setTypeFilter] = useState("0");
  const [List, setList] = useState([]);
  const [monthError, setMonthError] = useState("");
  const [yearError, setYearError] = useState("");
  const [typeError, setTypeError] = useState("");
  const [levelList, SetLevelList] = useState([]);
  const [selectedOption, setSelectedOption] = useState("0");
  const [CourceList, setCourceList] = useState([]);
  const [CourseFilter, setCourseFilter] = useState("0");

  const handleFilterChange = (selectedValues, filterType) => {
    debugger;
    let currentMonth = monthFilter;
    let currentYear = yearFilter;
    let type = selectedOption.value;
    let Coursee = CourseFilter;
    if (type == undefined) {
      type = "0";
    }
    switch (filterType) {
      case "month":
        setMonthFilter(selectedValues);
        currentMonth = selectedValues.join(",");

        break;
      case "year":
        setYearFilter(selectedValues);
        currentYear = selectedValues.join(",");

        break;
      case "type":
        setTypeFilter(selectedValues);
        type = selectedValues.join(",");
        break;
      case "course":
        setCourseFilter(selectedValues);
        Coursee = selectedValues.join(",");
        break;
      default:
        break;
    }

    FundReport(type, currentMonth, currentYear, Coursee);
  };

  const FundReport = (flag, month, year, Coursee) => {
    repObj
      .Report_FundReport(flag, month, year, Coursee)
      .then((res) => {
        if (res.data != null) {
          debugger;
          const data = res.data.map((item) => {
            if (item.createdDate) {
              const date = new Date(item.createdDate);
              const day = String(date.getDate()).padStart(2, "0");
              const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
              const year = date.getFullYear();
              return {
                ...item,
                createdDate: `${day}-${month}-${year}`, // overwrite formatted
              };
            }
            return item;
          });

          setList(data);
          // Process the response
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    $(".submenu").removeClass("active");
    $("#ReportMenu").addClass("active");

    $(".collapse").removeClass("show");
    $("#FundReport").addClass("show");
    window.scrollTo(0, 0);
    var id = 1;
    AppService.GetStepDropDownList(id).then((res) => {
      console.log(res.data);
      if (res != null && res.data != null && res.data.length > 0) {
        const options = res.data.map((item) => ({
          value: item.roleID,
          label: item.roleName,
        }));
        SetLevelList(options);
      } else {
        SetLevelList([]);
      }
    });

    AppService.GetCourse()
      .then((res) => {
        if (res.data != null) {
          const options = res.data.map((item) => ({
            value: item.course,
            label: item.course,
          }));

          setCourceList(options);
          // Process the response
        }
      })
      .catch((err) => {
        console.log(err);
      });

    handleFilterChange();
  }, []);

  const columns = [
    { name: "ticketNumber", label: "Ticket No" },
    { name: "fundType", label: "Fund Type" },
    { name: "studentName", label: "Student Name" },
    { name: "course", label: "Course" },
    { name: "studentStatus", label: "Student Status" },

    { name: "ticketDetails", label: "Ticket Details" },
    { name: "amount", label: "Amount" },
    { name: "billNumber", label: "Bill Number" },
    {
      name: "createdDate",
      label: "Requested Date",
      options: {
        customBodyRender: (value) => {
          const date = new Date(value);
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        },
      },
    },

    {
      name: "status",
      label: "Status",
      //   options: {
      //     customBodyRender: (value, tableMeta) => {
      //       const rowIndex = tableMeta.rowIndex;
      //       const Status = List[rowIndex].isSubmit;
      //       return (
      //         <p>
      //           {Status == 1
      //             ? "Request"
      //             : Status == 2
      //             ? "1st Level Approved"
      //             : Status == 3
      //             ? "2nd Level Approved"
      //             : Status == 4
      //             ? "3rd Level Approved"
      //             : Status == 5
      //             ? "Credited"
      //             : "Rejected"}
      //         </p>
      //       );
      //     },
      //   },
    },
  ];

  const columns1 = [
    { name: "ticketNumber", label: "Ticket No" },
    { name: "fundType", label: "Fund Type" },
    { name: "studentName", label: "Student Name" },
    { name: "course", label: "Course" },
    { name: "studentStatus", label: "Student Status" },

    { name: "ticketDetails", label: "Ticket Details" },
    { name: "amount", label: "Amount" },
    { name: "billNumber", label: "Bill Number" },
    {
      name: "createdDate",
      label: "Requested Date",
      // options: {
      //   customBodyRender: (value) => {
      //     try {
      //       const date = new Date(value);
      //       // Check if date is valid
      //       if (isNaN(date.getTime())) {
      //         return "Invalid date";
      //       }
      //       const day = date.getDate().toString().padStart(2, "0");
      //       const month = (date.getMonth() + 1).toString().padStart(2, "0");
      //       const year = date.getFullYear();
      //       return `${day}-${month}-${year}`;
      //     } catch (error) {
      //       return "Invalid date";
      //     }
      //   },
      // },
    },

    {
      name: "status",
      label: "Status",
      //   options: {
      //     customBodyRender: (value, tableMeta) => {
      //       const rowIndex = tableMeta.rowIndex;
      //       const Status = List[rowIndex].isSubmit;
      //       return (
      //         <p>
      //           {Status == 1
      //             ? "Request"
      //             : Status == 2
      //             ? "1st Level Approved"
      //             : Status == 3
      //             ? "2nd Level Approved"
      //             : Status == 4
      //             ? "3rd Level Approved"
      //             : Status == 5
      //             ? "Credited"
      //             : "Rejected"}
      //         </p>
      //       );
      //     },
      //   },
    },
  ];
  // const getStatusLabel = (status) => {
  //     switch (status) {
  //         case 1:
  //             return "Requested";
  //         case 2:
  //             return "1st Level Approved";
  //         case 3:
  //             return "2nd Level Approved";
  //         case 4:
  //             return "3rd Level Approved";
  //         case 5:
  //             return "Credited";
  //         default:
  //             return "Rejected";
  //     }
  // };
  const options = {
    responsive: true,
    download: false,
    print: true,
    selectableRows: false,
    filter: true,
    viewColumns: true,
    customToolbar: () => (
      <>
        <Tooltip title="Export to Excel">
          <IconButton
            onClick={() => exportToExcel(List, columns1, "FundReports.xlsx")}
          >
            <GetAppIcon />
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const allMonths = [
    ...Array.from({ length: 12 }, (_, index) => ({
      value: index + 1,
      label: new Date(0, index).toLocaleString("default", { month: "long" }),
    })),
  ];

  // Assuming you want to show a range of years, adjust the range as needed
  const currentYear = new Date().getFullYear();
  const yearsRange = Array.from(
    { length: 3 },
    (_, index) => currentYear - index
  );

  const allYears = [
    ...yearsRange.map((year) => ({ value: year, label: year })),
  ];

  // const handleChange = (selectedOptions) => {
  //   debugger;
  //   const selectedValues = selectedOptions
  //     .map((option) => option.value)
  //     .join(",");

  //   setSelectedOption(selectedOptions);

  //   repObj
  //     .Report_FundReport(selectedValues, monthFilter, yearFilter)
  //     .then((res) => {
  //       if (res.data != null) {
  //         setList(res?.data);
  //         // Process the response
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const handleChange = (selectedOption) => {
    debugger;
    setSelectedOption(selectedOption);

    const selectedValue = selectedOption.value; // Access the value property

    repObj
      .Report_FundReport(selectedValue, monthFilter, yearFilter, CourseFilter)
      .then((res) => {
        if (res.data != null) {
          setList(res?.data);
          // Process the response
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const dropdownTypeFilter = [
    { value: "0", label: "All" },
    { value: "1", label: "Requested" },
    { value: "2", label: "1st Level Approved" },
    { value: "3", label: "2nd Level Approved" },
    { value: "4", label: "3rd Level Approved" },
    { value: "5", label: "Credited" },
    { value: "6", label: "Rejected" },
  ];
  return (
    <div className="main-panel">
      <div className="content">
        <div className="page-inner">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-filters">
                    <div className="row">
                      <div class="col-lg-4 mb-2">
                        <div class="form-group">
                          <label class="text-label form-label">
                            Month <span class="text-danger"></span>
                          </label>
                          <Select
                            options={allMonths}
                            value={allMonths.find(
                              (month) => month.value === monthFilter
                            )}
                            isMulti
                            onChange={(selectedOptions) => {
                              const selectedValues = selectedOptions.map(
                                (option) => option.value
                              );
                              handleFilterChange(selectedValues, "month");
                            }}
                          />
                          {/* {monthError != "" ? <div class="invalid-feedback" style={{ display: "block" }}>
                                                        {monthError}
                                                    </div> : <></>} */}
                        </div>
                      </div>

                      <div class="col-lg-4 mb-2">
                        <div class="form-group">
                          <label class="text-label form-label">
                            Year <span class="text-danger"></span>
                          </label>
                          <Select
                            options={allYears}
                            value={allYears.find(
                              (year) => year.value === yearFilter
                            )}
                            isMulti
                            onChange={(selectedOptions) => {
                              const selectedValues = selectedOptions.map(
                                (option) => option.value
                              );
                              handleFilterChange(selectedValues, "year");
                            }}
                          />
                          {/* {yearError != "" ? <div class="invalid-feedback" style={{ display: "block" }}>
                                                        {yearError}
                                                    </div> : <></>} */}
                        </div>
                      </div>
                      <div class="col-lg-4 mb-2">
                        <div class="form-group">
                          <label class="text-label form-label">
                            Course <span class="text-danger"></span>
                          </label>
                          <Select
                            options={CourceList}
                            value={CourceList.find(
                              (course) => course.value === CourseFilter
                            )}
                            isMulti
                            onChange={(selectedOptions) => {
                              const selectedValues = selectedOptions.map(
                                (option) => option.value
                              );
                              handleFilterChange(selectedValues, "course");
                            }}
                          />
                          {/* {monthError != "" ? <div class="invalid-feedback" style={{ display: "block" }}>
                                                        {monthError}
                                                    </div> : <></>} */}
                        </div>
                      </div>
                      <div class="col-lg-4 mb-2">
                        <div class="form-group">
                          <label class="text-label form-label">
                            Type Filter <span class="text-danger"></span>
                          </label>
                          <Select
                            options={levelList}
                            value={selectedOption}
                            onChange={handleChange}
                          />
                          {typeError != "" ? (
                            <div
                              class="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {typeError}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <MUIDataTable
                      title="Fund Reports"
                      data={List} // Use your actual data here
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundReport;
